/** Only the recorded purchase platform can identify the shop; never infer it from a catalog URL or route. */
export const purchaseOrderUrl = (
  purchaseOrderNumber?: string | null,
  purchasePlatform?: string | null,
): string | null => {
  const orderNumber = (purchaseOrderNumber ?? '').trim();
  if (!/^\d+$/.test(orderNumber)) {
    return null;
  }

  switch (purchasePlatform) {
    case 'COUPANG':
      return `https://mc.coupang.com/ssr/desktop/order/${orderNumber}`;
    case 'NAVER':
      return `https://orders.pay.naver.com/order/status/${orderNumber}`;
    default:
      return null;
  }
};
